import { mountClinicalNavigationEnhancements } from "./clinical-navigation-enhancements";

mountClinicalNavigationEnhancements();
